import React from 'react';
import { JcNote } from '../JcNote';
import { JcCommonProps, JcUtils } from '../../utils/JcUtils';

export interface JcAppFooterProps extends JcCommonProps {
    readonly children?: React.ReactNode;
    readonly copyrightText: string;
}

export const JcAppFooter = (props: JcAppFooterProps): React.ReactElement => {
    const commonProps = JcUtils.commonProps(props, ["jc-app-footer"]);
    return <footer {...commonProps}>
        {props.children}
        <JcNote className="jc-app-copyright" text={props.copyrightText} />
    </footer>;
};
